const reducerKey = 'global'

export const selectLocale = (state) => state[reducerKey].locale
